import { render } from "./LiveStream.vue?vue&type=template&id=bafdefda"
import script from "./LiveStream.vue?vue&type=script&lang=js"
export * from "./LiveStream.vue?vue&type=script&lang=js"

import "./LiveStream.vue?vue&type=style&index=0&id=bafdefda&lang=scss"

import exportComponent from "C:\\Workspaces\\livetv\\vuefront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__